export const SESSIONS_STATES = {
  IN_PROGRESS: "En progreso",
  COMPLETE: "Completado",
  ASIGNED: "Asignado",
  CANCELLED: "Cancelado"
};

export const SESSIONS_MESSAGES = {
  SESSION_ERROR: "Hubo un error al reiniciar la sesión, intenta mas tarde"
};

export const SESSION_CONSTANTS = {
  RESTART_SESSION: "restartSession"
};
